<script>
export default {
  name: "WaybillPrintConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectedOrder: {
      type: Object,
      default: null
    }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  computed: {
    dialogTitle() {
      if (this.selectedOrder?.waybillPrinted) return "운송장 재출력 확인"
      return "운송장 출력 확인"
    },
    dialogMessage() {
      if (this.selectedOrder?.waybillPrinted) {
        return `${this.selectedOrder.orderNo || "-"} 오더는 이미 운송장이 출력된 상태입니다. 다시 출력하시겠습니까?`
      }
      return `${this.selectedOrder?.orderNo || "-"} 오더의 운송장을 출력하시겠습니까?`
    }
  },
  methods: {
    onCancel() {
      this.$emit("cancel")
    },
    onConfirm() {
      this.$emit("confirm")
    }
  }
}
</script>

<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <q-card class="confirm-modal">
      <q-card-section class="q-pb-sm">
        <div class="text-h6">{{ dialogTitle }}</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        {{ dialogMessage }}
      </q-card-section>
      <q-card-actions align="right" class="q-pa-md q-pt-none">
        <q-btn flat label="취소" @click="onCancel" />
        <q-btn color="primary" label="출력" @click="onConfirm" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.confirm-modal {
  width: 420px;
  max-width: 92vw;
}
</style>
